import { Tab, Tabs, useTheme } from '@mui/material';
import { Table } from '@tanstack/react-table';
import { useAtom, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { useSubmitterLabelOptions } from '../../../queries/hooks/useSubmitterLabelOptions';
import { tsStatuesSelectedOPs, tsStatusesSubmitterLabel } from '../../../state/UIAccountantState';
import { UserWithTsPeriodData } from '../../../types';

type Props = {
  table: Table<UserWithTsPeriodData>;
};

/** All Submitters / one tab per Submitter-stage label (e.g. Asset Servicer, Operating Partner). */
export function SubmitterTabs({ table }: Props) {
  const { colors } = useTheme();
  const submitterOptions = useSubmitterLabelOptions();
  const [submitterLabel, setSubmitterLabel] = useAtom(tsStatusesSubmitterLabel);
  const setSelectedOPs = useSetAtom(tsStatuesSelectedOPs);

  const onChangeTab = useCallback(
    (_: React.SyntheticEvent, label: string) => {
      setSubmitterLabel(label);
      setSelectedOPs([]);
      table.getColumn('name')?.setFilterValue([]);
    },
    [setSubmitterLabel, setSelectedOPs, table]
  );

  const tabStyle = {
    color: colors.text.main,
    textTransform: 'none',
    fontSize: '14px',
    paddingLeft: '1rem',
    paddingRight: '1rem',
  };

  return (
    <Tabs
      // While workflows load only "All Submitters" exists; avoid MUI's unknown-value warning.
      value={submitterOptions.some((option) => option.id === submitterLabel) ? submitterLabel : false}
      onChange={onChangeTab}
      sx={{ marginBottom: '1rem' }}
    >
      {submitterOptions.map((option) => (
        <Tab key={option.id} label={option.value} value={String(option.id)} sx={tabStyle} />
      ))}
    </Tabs>
  );
}
